import { inject, Service } from "@angular/core"
import { Observable } from "rxjs"
import { HttpClient } from "@angular/common/http"
import { Perk, PagedPerk, CreatePerk, ModifyObject } from "../models"
import { environment } from "src/environments/environment"

export interface ColumnFilter {
    field: string
    value: string
    matchMode: string
}

export interface GetPerkPagedParams {
    search?: string
    sortField?: string
    sortDescending?: boolean
    page: number
    pageSize: number
    columnFilters?: ColumnFilter[]
}

@Service({ autoProvided: false })
export class PerksService {
    private _http = inject(HttpClient)
    private _apiUrl = environment.apiBaseUrl + environment.endpointRoutes.perks

    Get(): Observable<Perk[]> {
        return this._http.get<Perk[]>(this._apiUrl)
    }

    GetOne(masterId: string): Observable<Perk> {
        return this._http.get<Perk>(this.ByMasterIdUrl(masterId))
    }
    ByMasterIdUrl(masterId: string): string {
        return `${this._apiUrl}/${masterId}`
    }

    GetPaged(params: GetPerkPagedParams): Observable<PagedPerk> {
        const request = this.PagedRequest(params)
        return this._http.get<PagedPerk>(request.url, { params: request.params })
    }
    PagedRequest(params: GetPerkPagedParams): { url: string; params: Record<string, string> } {
        const httpParams: Record<string, string> = {
            page: params.page.toString(),
            pageSize: params.pageSize.toString(),
        }
        if (params.search) httpParams["search"] = params.search
        if (params.sortField) httpParams["sortField"] = params.sortField
        if (params.sortDescending !== undefined) httpParams["sortDescending"] = params.sortDescending.toString()
        if (params.columnFilters?.length) httpParams["columnFilters"] = JSON.stringify(params.columnFilters)

        return { url: this._apiUrl + "/paged", params: httpParams }
    }

    Create(createPerk: CreatePerk): Observable<Perk> {
        const { link, contact, ...rest } = createPerk
        return this._http.post<Perk>(this._apiUrl, {
            ...rest,
            activeFrom: rest.activeFrom || null,
            activeTo: rest.activeTo || null,
        })
    }

    Modify(masterId: string, data: ModifyObject): Observable<Perk> {
        return this._http.patch<Perk>(this.ByMasterIdUrl(masterId), data)
    }

    Delete(masterId: string): Observable<string> {
        return this._http.delete<string>(this.ByMasterIdUrl(masterId))
    }
}
